var render, staticRenderFns
import script from "./AdvertManage.vue?vue&type=script&lang=js&"
export * from "./AdvertManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f559790')) {
      api.createRecord('5f559790', component.options)
    } else {
      api.reload('5f559790', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Advert/resources/vue/AdvertManage.vue"
export default component.exports